export enum SignUpProcessingModelEnum {
  Instalment = 'INSTALMENT',
  None = 'NONE',
  Recurring = 'RECURRING',
  UnscheduledCredentialOnFile = 'UNSCHEDULED_CREDENTIAL_ON_FILE',
}
